export default __webpack_public_path__ + "static/media/foto_claudio.35a46b6b.png";